module.exports = __webpack_public_path__ + "img/square-half.12321d70.svg";